import {API_DRIVER} from "../config/axios";
import {WishType} from "../store/wish/Helper";

const getDashboardRequestUrl = (endpointUrl: string) => {
    return `/api/dashboard${endpointUrl}`
}

const DashboardService = {
    fetchTotalTicketsPlot: (startDate: string, endDate: string, wishType: WishType) => {
        return API_DRIVER.get(getDashboardRequestUrl('/total-tickets'), {
            params: {
                start_date: startDate,
                end_date: endDate,
                wish_type: wishType
            }
        })
    },
    fetchClientTotalTicketsPlot: (startDate: string, endDate: string, wishType: WishType) => {
        return API_DRIVER.get(getDashboardRequestUrl('/wish-voucher-total-tickets-for-client'), {
            params: {
                start_date: startDate,
                end_date: endDate,
                wish_type: wishType
            }
        })
    },
    fetchCategoriesPopularityPlot: (categoryIds: string[], wishType: WishType) => {
        return API_DRIVER.post(getDashboardRequestUrl('/wish-popularity-per-category'), categoryIds, {
            params: {
                wish_type: wishType
            }
        })
    },
    fetchUsersPerMonthPlot: (startDate: string, endDate: string) => {
        return API_DRIVER.get(getDashboardRequestUrl('/new-users-per-month'), {
            params: {
                start_date: startDate,
                end_date: endDate
            }
        })
    },
    fetchPayingUsersPerMonthPlot: (startDate: string, endDate: string) => {
        return API_DRIVER.get(getDashboardRequestUrl('/paying-users-per-month'), {
            params: {
                start_date: startDate,
                end_date: endDate
            }
        })
    },
    fetchExpensesPerMonthPlot: (startDate: string, endDate: string) => {
        return API_DRIVER.get(getDashboardRequestUrl('/expenses-per-month'), {
            params: {
                start_date: startDate,
                end_date: endDate
            }
        })
    },
    fetchTicketsPerMonthPlot: (startDate: string, endDate: string, wishType: WishType) => {
        return API_DRIVER.get(getDashboardRequestUrl('/tickets-bought-per-month'), {
            params: {
                start_date: startDate,
                end_date: endDate,
                wish_type: wishType
            }
        })
    },
    fetchWishPopularityPerCost: (wishType: WishType) => {
        return API_DRIVER.get(getDashboardRequestUrl('/wish-popularity-per-cost'), {
            params: {
                wish_type: wishType
            }
        })
    },
    fetchWishPopularityPerPointsAward: () => {
        return API_DRIVER.get(getDashboardRequestUrl('/wish-voucher-popularity-per-points-award'))
    },
    fetchUsersCountPerGender: () => {
        return API_DRIVER.get(getDashboardRequestUrl('/users-count-by-gender'))
    },
    fetchClientTickets: (wishType: WishType) => {
        return API_DRIVER.get(getDashboardRequestUrl('/total-tickets-for-client'), {
            params: {
                wish_type: wishType
            }
        })
    },
    fetchClientTicketsPerWish: (wishType: WishType) => {
        return API_DRIVER.get(getDashboardRequestUrl('/tickets-per-wish-for-client'), {
            params: {
                wish_type: wishType
            }
        })
    },
    fetchWishPopularityPerPointsAwardForClient: () => {
        return API_DRIVER.get(getDashboardRequestUrl('/wish-voucher-popularity-per-points-award-for-client'))
    },
    fetchClientProfitPerMonth: () => {
        return API_DRIVER.get(getDashboardRequestUrl('/client-profit-per-month'))
    },
    fetchAdminProfitPerMonth: (startDate: string, endDate: string) => {
        return API_DRIVER.get(getDashboardRequestUrl('/admin-profit-per-month'), {
            params: {
                start_date: startDate,
                end_date: endDate
            }
        })
    }
}

export default DashboardService
